/* @sravni/react-design-system version 0.2.65 */
import { __rest, __spreadArray, __read, __assign } from 'tslib';
import * as React from 'react';
import { isUndefined, isNumber, useStyles } from '@sravni/react-utils';
import RowContext from './RowContext.js';
import modules_a7ef704f from '../styles/Col.module.less.js';

/** Helper function */
var convertSpanAdaptiveToClassNames = function (span) {
    if (isUndefined(span))
        return [];
    var breakpoints = Object.keys(span);
    var createName = function (breakpoint) {
        return breakpoint === 'mobile' ? span[breakpoint] : breakpoint + "-" + span[breakpoint];
    };
    return breakpoints.map(function (breakpoint) { return "span-" + createName(breakpoint); });
};
/** Helper function */
var convertOrderAdaptiveToClassNames = function (order) {
    if (isUndefined(order))
        return [];
    var breakpoints = Object.keys(order);
    var createName = function (breakpoint) {
        return breakpoint === 'mobile' ? order[breakpoint] : breakpoint + "-" + order[breakpoint];
    };
    return breakpoints.map(function (breakpoint) { return "order-" + createName(breakpoint); });
};
/** Helper function */
var convertOffsetAdaptiveToClassNames = function (offset) {
    if (isUndefined(offset))
        return [];
    var breakpoints = Object.keys(offset);
    var createName = function (breakpoint) {
        return breakpoint === 'mobile' ? offset[breakpoint] : breakpoint + "-" + offset[breakpoint];
    };
    return breakpoints.map(function (breakpoint) { return "offset-" + createName(breakpoint); });
};
/**
 * @description Column element for Grid system.
 *
 * @component
 * @example
 * ```jsx
 * <Col span={3}>
 *   Column
 * </Col>
 * <Col span={{ mobile: 3, tablet: 2, desktop: 2}} order={{ mobile: 3, tablet: 2, desktop: 1}}>
 *   Column
 * </Col>
 * ```
 */
var Col = React.forwardRef(function (props, ref) {
    var className = props.className, span = props.span, order = props.order, offset = props.offset, style = props.style, children = props.children, restProps = __rest(props, ["className", "span", "order", "offset", "style", "children"]);
    var spanAdaptive = React.useMemo(function () { return (isNumber(span) ? { mobile: span } : span); }, [span]);
    var orderAdaptive = React.useMemo(function () { return (isNumber(order) ? { mobile: order } : order); }, [order]);
    var offsetAdaptive = React.useMemo(function () { return (isNumber(offset) ? { mobile: offset } : offset); }, [offset]);
    var cx = useStyles(modules_a7ef704f);
    var classNames = cx.apply(void 0, __spreadArray(__spreadArray(__spreadArray([className,
        'container'], __read(convertSpanAdaptiveToClassNames(spanAdaptive))), __read(convertOrderAdaptiveToClassNames(orderAdaptive))), __read(convertOffsetAdaptiveToClassNames(offsetAdaptive))));
    var gutter = React.useContext(RowContext).gutter;
    var mergedStyle = __assign({}, style);
    // Horizontal gutter use padding
    if (gutter && gutter[0] > 0) {
        var horizontalGutter = gutter[0] / 2;
        mergedStyle.paddingLeft = horizontalGutter;
        mergedStyle.paddingRight = horizontalGutter;
    }
    // Vertical gutter use padding when gap not support
    if (gutter && gutter[1] > 0) {
        var verticalGutter = gutter[1] / 2;
        mergedStyle.paddingTop = verticalGutter;
        mergedStyle.paddingBottom = verticalGutter;
    }
    return (React.createElement("div", __assign({ "data-qa": "Col", ref: ref, className: classNames, style: __assign({}, mergedStyle) }, restProps), children));
});
Col.defaultProps = {};
Col.displayName = 'Col';

export default Col;
//# sourceMappingURL=Col.js.map
